module.exports = __webpack_public_path__ + "static/media/04-0204.dc7970dd.png";